
import ClientsProps from './types';

export default {
  name: 'LogoPrograma',
  props: {
    alt: {
      type: String,
      default: `Logo ${process.env.VUE_APP_TITLE}`,
    },
    client: {
      type: String,
      default: 'regenera',
      validator(value: typeof ClientsProps[number]) {
        return ClientsProps.indexOf(value) !== -1;
      },
    },
    height: String,
    width: String,
  },
};
